import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { durationTime } from '@/utils/const'
import i18n from '@/lang'
import qs from 'qs'
import router from '@/router'

const service = axios.create({
  // api 的 base_url
  // baseURL: process.env.BASE_API,
  baseURL: '/api',
  // 请求超时时间
  timeout: 0,
  withCredentials: true,
  transformRequest: [
    function(data) {
      data = qs.stringify(data)
      return data
    }
  ],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (config.params) {
      config.params.lang = store.getters.language
    } else {
      config.params = {}
      config.params.lang = store.getters.language
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    const result = response.data
    // debugger
    // 401：session过期
    if (result.status === 401) {
      Message({
        message: result.msg,
        type: 'error',
        duration: durationTime
      })
      store.dispatch('FedLogout').then(() => {
        // 为了重新实例化vue-router对象 避免bug
        location.reload()
        // this.$router.push({ path: '/' })
        router.replace({path: '/'})
      })
      return Promise.reject(result.msg)
    } else if (result.status === 403) {
      // 403：没有权限访问
      Message({
        message: result.msg,
        type: 'error',
        duration: durationTime
      })
      store.dispatch('Logout').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
      return Promise.reject(result.msg)
    } else if (result.status !== 200) {
      Message({
        message: result.msg,
        type: 'error',
        duration: durationTime
      })
      return Promise.reject(result.msg)
    } else {
      return result
    }
  },
  error => {
    if (error.response.status === 404) {
      Message({
        message: i18n.t('request.interface404', [error.response.data.path]),
        type: 'error',
        duration: durationTime
      })
      return Promise.reject(error)
    } else if (error.response.status === 504) {
      Message({
        message: i18n.t('request.interface504'),
        type: 'error',
        duration: durationTime
      })
      return Promise.reject(error)
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: durationTime
      })
      return Promise.reject(error)
    }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// /**
//  * put方法，对应put请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function put (url, params) {
//   return axios({
//     method: 'put',
//     url: url,
//     data: params,
//     transformRequest: [function (data) {
//       let ret = ''
//       for (let it in data) {
//         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
//       }
//       return ret
//     }],
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     }
//   });
// }

// /**
//  * delete方法，对应delete请求
//  * @param {String} url [请求的url地址]
//  */
// export function delete(url) {
//   return service.delete({
//     method: 'delete',
//     url: url
//   });
// }



// WEBPACK FOOTER //
// ./src/utils/request.js